import { useHistory } from "react-router-dom";
import React, { useState } from "react";
import general from "../../general";
import { CloseOutlined } from "@ant-design/icons";
import { useInterval } from "ahooks";
import { prod } from "../../config";
import useActiveState from "../../lib/useActiveState";
import Dialog from "../../lib/Dialog";
import CryptoJS from "crypto-js";
import dayjs from "dayjs";

// 绑定手机号
export default (props) => {
  const history = useHistory();
  const [user, setUser] = useActiveState("user");
  const [data, setData] = useState(
    !prod ? { mobile: "13227737527", code: "123456" } : {}
  );
  const [focus, setFocus] = useState("");

  const [coding, setCoding] = useState(false);
  const [codeTime, setCodeTime] = useState(0);
  useInterval(() => {
    if (codeTime) {
      setCodeTime(codeTime - 1);
    }
  }, 1000);

  const encodeAndHash = (value) => {
    // Base64 编码
    const base64Encoded = CryptoJS.enc.Base64.stringify(
      CryptoJS.enc.Utf8.parse(value)
    );

    // MD5 加密
    const md5Hash = CryptoJS.MD5(base64Encoded).toString(CryptoJS.enc.Hex);

    return md5Hash;
  };

  const code = () => {
    if (!data.mobile) {
      Dialog.error("请输入手机号");
      return;
    }
    if (coding || codeTime) {
      return;
    }
    setCoding(true);
    Dialog.loading();

    let str = `02${data.mobile}${dayjs().unix().toString()}`;
    general.axios
      .post("/v3/base/tool/getVerifyCode", {
        mobile: data.mobile,
        code: "code",
        type: "02",
        time: dayjs().unix().toString(),
        sign: encodeAndHash(str),
      })
      .finally(() => {
        setCoding(false);
        Dialog.close();
      })
      .then((response) => {
        let result = response.data;
        if (!result.status.succeed) {
          Dialog.error(result.status.error_desc);
        } else {
          setCodeTime(60);
        }
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };

  const [saving, setSaving] = useState(false);
  const save = () => {
    if (saving) {
      return;
    }
    if (!data.mobile) {
      Dialog.error("请输入手机号");
      return;
    }
    if (!data.code) {
      Dialog.error("请输入验证码");
      return;
    }
    setSaving(true);
    Dialog.loading();
    general.axios
      .post("/v3/user/user/bindPhone", data)
      .finally(() => {
        setSaving(false);
        Dialog.close();
      })
      .then((res) => {
        let { status } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          Dialog.success("保存成功", () => {
            setUser({
              ...user,
              mobile: data.mobile.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2"),
            });
            history.goBack();
          });
        }
      })
      .catch((err) => {
        Dialog.error("bindPhone " + err.message);
      });
  };

  return (
    <div className="user-phone-bind">
      <div className="user-phone-bind-main">
        <div className="phone-input">
          <div className="phone-name">手机号</div>
          <input
            name="mobile"
            type="text"
            value={data.mobile}
            placeholder="请输入手机号"
            autoComplete="off"
            onFocus={() => setFocus("mobile")}
            onChange={(e) => setData({ ...data, mobile: e.target.value })}
          />
          {focus === "mobile" && data.mobile ? (
            <CloseOutlined
              className="close"
              onClick={() => setData({ ...data, mobile: "" })}
            />
          ) : null}
        </div>
        <div className="phone-input">
          <div className="phone-name">验证码</div>
          <input
            name="code"
            type="text"
            value={data.code}
            placeholder="请输入验证码"
            autoComplete="off"
            onFocus={() => setFocus("code")}
            onChange={(e) => setData({ ...data, code: e.target.value })}
          />
          <div
            className={"code-btn " + (coding || codeTime ? "disable" : "")}
            onClick={code}
          >
            {coding
              ? "发送中"
              : codeTime
              ? codeTime + "秒后重试"
              : "获取验证码"}
          </div>
        </div>
      </div>

      <div className="phone-bind-btn" onClick={save}>
        保存
      </div>
    </div>
  );
};
